/** CSGMesh3D strict validators for linting. */
import '../csgprimitive3d/linterParser.js';
import { validatorRegistry } from '../../../../linter/ValidatorRegistry.js';
import { v } from '../../../../linter/validators/index.js';
// `transform` comes from the Node3D base walk and is deliberately not shadowed here.
validatorRegistry.registerAll('CSGMesh3D', {
    mesh: v.resourceReference('mesh'),
    material: v.resourceReference('material'),
});
//# sourceMappingURL=linterParser.js.map